(function(){
  'use strict';
  if (window.__hsBlogPopupLoaded) return;
  window.__hsBlogPopupLoaded = true;

  // Detect mobile via media query — matches iPhone, Android phones, NOT
  // iPad. Used to swap stricter desktop thresholds for laxer mobile ones
  // since touch UAs lack mouseleave (no exit-intent) and bounce far faster.
  var isMobile = false;
  try { isMobile = window.matchMedia && window.matchMedia('(max-width:640px)').matches; } catch (e) {}

  var CFG = {
    // Vercel API — these endpoints stay server-side (no way to run them
    // from a theme asset). Keep in sync with the middleware allowlist
    // (/api/blog-popup is public).
    apiBase: 'https://analytics-gilt-beta.vercel.app',
    brand: null,
    // Liquid resolves to the theme CDN URL at build time. If the file
    // hasn't been uploaded, this becomes `/files/blog-popup-hero.jpg`
    // which 404s → the onerror handler swaps to the fallback product image.
    lifestyleImg: "\/\/healing-sounds.com\/cdn\/shop\/t\/2\/assets\/blog-popup-hero.jpg?v=7600",
    lifestyleFallback: 'https://cdn.shopify.com/s/files/1/0864/3946/1213/files/26-chau-gong-c-stand-meditation-instrument-large-chinese-156.jpg?v=1733775344',
    avatars: [
      'https://cdn.shopify.com/s/files/1/0864/3946/1213/files/review-hs-3.jpg?v=1759903052',
      'https://cdn.shopify.com/s/files/1/0864/3946/1213/files/review-hs-1.jpg?v=1759903052',
      'https://cdn.shopify.com/s/files/1/0864/3946/1213/files/review-hs-2.jpg?v=1759903052'
    ],
    // Trigger thresholds — re-tuned 2026-04-27 (timer down + cooldown 3d)
    // because aggregate show rate was stuck at 1-3% (target 10-15%).
    // Rule = scroll % OR timer OR scroll-pause OR exit-intent (desktop).
    scrollPct: isMobile ? 25 : 30,
    timeTriggerMs: isMobile ? 8000 : 12000,
    scrollPausePixels: isMobile ? 200 : 350,
    scrollPauseMs: isMobile ? 2000 : 2500,
    dismissDays: 3,
    skipPathPrefixes: ['/cart', '/checkout', '/checkouts', '/account', '/password', '/challenge'],
    successAutoCloseMs: 4500,
    brandPrimary: '#967AB6',
    brandDark: '#7A5F9A'
  };

  var LS_DISMISSED = '_hs_blog_popup_dismissed_at';
  var LS_SUBSCRIBED = '_hs_blog_popup_subscribed';

  // Test mode: ?blog_popup_test=1 OR window.__hsBlogPopupTest=true
  var isTestMode = /[?&]blog_popup_test=1/.test(location.search) || window.__hsBlogPopupTest === true;

  // Early-exit guards
  var path = (location.pathname || '/').toLowerCase();
  if (!isTestMode && path.indexOf('/blogs/') < 0) return;
  if (!isTestMode) {
    for (var i = 0; i < CFG.skipPathPrefixes.length; i++) {
      if (path.indexOf(CFG.skipPathPrefixes[i]) === 0) return;
    }
  }
  // Logged-in Shopify customer → likely already on list. Liquid gives us a
  // compile-time signal; JS check stays as a defensive fallback (theme JS
  // may refresh without re-rendering Liquid).
  
  try {
    if (!isTestMode && window.Shopify && window.Shopify.customer && window.Shopify.customer.id) return;
  } catch (e) {}
  try {
    if (!isTestMode && localStorage.getItem(LS_SUBSCRIBED) === '1') return;
  } catch (e) {}
  try {
    if (!isTestMode) {
      var dismissedAt = parseInt(localStorage.getItem(LS_DISMISSED) || '0', 10);
      if (dismissedAt && (Date.now() - dismissedAt) < CFG.dismissDays * 24 * 3600 * 1000) return;
    }
  } catch (e) {}

  // Topic taxonomy — 14 sub-topics + default. Kept in sync with the
  // Vercel widget.js at /src/app/api/blog-popup/widget.js/route.ts.
  // Each topic has its own hero `image` (curated from the HS product catalog)
  // so the popup always shows a relevant photo — not a generic gong for all.
  var IMG_CDN = 'https://cdn.shopify.com/s/files/1/0864/3946/1213/files/';
  // Topic match priority is TOP-DOWN in this array. Instrument-specific
  // sub-topics (kalimba, handpan, tongue-drum, etc.) MUST come before
  // generic keywords like "drum" / "flute" / "chime" that would
  // otherwise swallow them.
  //
  // HS operates 25 blogs on Shopify (one per instrument/category); each
  // entry below maps to at least one blog. The blog handle ends up in
  // location.pathname, so matching on the handle keyword is the most
  // reliable signal.
  var TOPICS = [
    // ---- Instrument-specific sub-topics (per Shopify blog) ----
    { key: 'kalimba', image: IMG_CDN + '17-key-gabonese-rosewood-c-tone-kalimba-thumb-piano-keys-ore-metal-880.jpg?v=1715789855', test: /(\bkalimba\b|thumb[-_ ]piano)/i, eyebrow: 'For kalimba players', headline: 'Start playing kalimba today', sub: 'Tuning tips, simple songs, and 10% off your first kalimba.', benefit1: 'Free tabs for 5 easy songs', benefit2: '17 vs 21-key · which one for your hands' },
    { key: 'handpan', image: IMG_CDN + 'b2-mystic-handpan-drum-perfect-beginners-pros-gold-432-hz-9-golden-bronze-707.jpg?v=1737855085', test: /(\bhandpan\b|hang[-_ ]drum|tongue[-_ ]drum[-_ ]handpan)/i, eyebrow: 'For handpan players', headline: 'Your handpan journey starts here', sub: 'Scale selection, care & first melodies — plus 10% off your first pan.', benefit1: 'D minor vs F# Kurd — which scale suits you', benefit2: 'Care basics: cloth, oil, and travel cases' },
    { key: 'tongue_drum', image: IMG_CDN + 'tongue-drum-steel-11-notes-blue.jpg?v=1770013661', test: /(tongue[-_ ]drum|steel[-_ ]tongue|tank[-_ ]drum)/i, eyebrow: 'For tongue drum players', headline: 'The steel tongue drum, demystified', sub: 'Size, notes, and scales that fit your practice — plus 10% off.', benefit1: '6 vs 8 vs 11 notes — which to choose', benefit2: 'Meditation-friendly tuning guide' },
    { key: 'pan_flutes', image: IMG_CDN + '26-pipe-pan-flute-bag-abs-plastic-instrument-26-white-air-filter-black-256.jpg?v=1737864088', test: /(pan[-_ ]flute|\bsiku\b|panpipe|zampo\u00f1a)/i, eyebrow: 'For pan flute players', headline: 'The pan flute, from Andes to your shelf', sub: 'Breath control, maintenance & selection — plus 10% off your first.', benefit1: 'Breath-control basics for a clean tone', benefit2: 'Traditional care & storage notes' },
    { key: 'native_flutes', image: IMG_CDN + 'g-f-f-e-d-bass-c-c-drone-flute-aromatic-cedar-order-make-handmade-low-432hz-674.jpg?v=1737858810', test: /(native[-_ ]american|cedarwood[-_ ]flute|\bnaf\b|love[-_ ]flute)/i, eyebrow: 'For native flute players', headline: 'The Native American flute tradition', sub: 'Keys, cedar notes, and ritual framing — plus 10% off your first flute.', benefit1: 'A vs D key — choosing for beginners', benefit2: 'Respectful, tradition-rooted guidance' },
    { key: 'chinese_flutes', image: IMG_CDN + '8-hole-g-key-bamboo-flute-beginners-pros-light-brown-traditional-wooden-486.jpg?v=1739019599', test: /(chinese[-_ ]flute|\bdizi\b|\bxiao\b|bamboo[-_ ]flute)/i, eyebrow: 'For Chinese flute players', headline: 'Dizi + Xiao, side by side', sub: 'Finger positions, membrane care & tone tips — plus 10% off.', benefit1: 'Dizi vs Xiao: which fits your sound', benefit2: 'Dimo (membrane) replacement walkthrough' },
    { key: 'ocarina', image: IMG_CDN + '12-hole-alto-c-ceramic-ocarina-flute-instrument-black-743.jpg?v=1715786525', test: /(\bocarina\b|zelda[-_ ]ocarina)/i, eyebrow: 'For ocarina players', headline: 'Ocarina basics — inside your first 30 minutes', sub: 'Fingerings, breath pressure & care — plus 10% off your first ocarina.', benefit1: '12-hole vs 6-hole — the honest difference', benefit2: 'Beginner song pack (Zelda & folk tabs)' },
    { key: 'didgeridoo', image: IMG_CDN + '55-professional-didgeridoo-instrument-roasted-wood-197.png?v=1768367222', test: /(\bdidgeridoo\b|\bdidj\b|yidaki|circular[-_ ]breathing)/i, eyebrow: 'For didgeridoo players', headline: 'The didgeridoo, from drone to practice', sub: 'Circular breathing, key choice & care — plus 10% off your first.', benefit1: '30-second circular breathing drill', benefit2: 'Key D vs C vs F — which suits your voice' },
    { key: 'wind_chimes', image: IMG_CDN + '18-solar-wind-chime-lantern-garden-decor-chimes-decorative-721.jpg?v=1735424239', test: /(wind[-_ ]chime|garden[-_ ]chime|\bchime\b)/i, eyebrow: 'For chime lovers', headline: 'Chimes that set the mood of a space', sub: 'Tone, tuning & placement — plus 10% off your first set.', benefit1: 'Tuning systems that feel intentional', benefit2: 'Placement for indoor vs outdoor' },
    { key: 'koshi_chimes', image: IMG_CDN + 'protective-carry-case-koshi-chime-set-4pc-5pc-8pc-bag-purple-876.jpg?v=1735429187', test: /(\bkoshi\b|koshi[-_ ]chime)/i, eyebrow: 'For Koshi chime lovers', headline: 'Koshi chimes — the quiet ritual bell', sub: 'Earth, air, water, fire — plus 10% off your first Koshi.', benefit1: 'Which element chime for which ritual', benefit2: 'Care + travel case picks' },
    { key: 'lyre_harps', image: IMG_CDN + '16-string-mahogany-lyre-harp-instrument-electric-wooden-287.jpg?v=1733781336', test: /(lyre[-_ ]harp|\blyre\b)/i, eyebrow: 'For lyre players', headline: 'The lyre — an ancient voice, learnable fast', sub: 'Tuning, technique & simple pieces — plus 10% off your first lyre.', benefit1: 'Your first melody in 10 minutes', benefit2: 'Re-tuning for minor / major keys' },
    { key: 'guzheng', image: IMG_CDN + '60-cm-mini-guzheng-paulownia-21-string-chinese-zither-gu-zheng-style-1-269.jpg?v=1735466496', test: /(\bguzheng\b|\bzither\b|chinese[-_ ]string)/i, eyebrow: 'For guzheng players', headline: 'The guzheng — 2,500 years of resonance', sub: 'Tuning, care & starter repertoire — plus 10% off your first.', benefit1: '21-string tuning step-by-step', benefit2: 'Starter pieces (pentatonic)' },
    { key: 'shamanic_drums', image: IMG_CDN + 'yakut-siberian-shamanic-drum-handmade-instrument-766.jpg?v=1768370551', test: /(shamanic[-_ ]drum|\bshaman\b|frame[-_ ]drum|ceremonial[-_ ]drum)/i, eyebrow: 'For shamanic practice', headline: 'Shamanic drums, used respectfully', sub: 'Materials, care & ritual framing — plus 10% off your first drum.', benefit1: 'Ethically sourced materials we trust', benefit2: 'Rhythm basics for healing practice' },
    { key: 'ocean_drums', image: IMG_CDN + '12-20-inch-ocean-drum-instrument-sound-bath-wave-574.jpg?v=1768366153', test: /(ocean[-_ ]drum|wave[-_ ]drum)/i, eyebrow: 'For sound-bath artists', headline: 'Ocean drums for immersive sessions', sub: 'Sizing, shell choice & sound-bath tips — plus 10% off.', benefit1: '12" vs 16" vs 20" for different rooms', benefit2: 'Mixing ocean drum with bowls + gongs' },
    { key: 'rain_sticks', image: IMG_CDN + '60cm-80cm-100-120cm-bamboo-rain-stick-percussion-instrument-decoratively-454.jpg?v=1739050278', test: /(rain[-_ ]stick|bamboo[-_ ]rain)/i, eyebrow: 'For sound-bath rituals', headline: 'Rain sticks — the softest transition', sub: 'Length, fill & use in sound baths — plus 10% off your first.', benefit1: 'Length guide (60cm → 120cm)', benefit2: 'Opening + closing cues with rain' },
    { key: 'jews_harps', image: IMG_CDN + 'stainless-steel-jews-harp-mouth-jaw-decorative-key-ornate-511.jpg?v=1737863760', test: /(jew.?s[-_ ]harp|\bjaw[-_ ]harp\b|mouth[-_ ]harp|khomus|morsing)/i, eyebrow: 'For Jew\u2019s harp players', headline: 'Jew\u2019s harp — a tradition you can hold', sub: 'Technique, care & selection — plus 10% off your first harp.', benefit1: 'Technique drill (tongue vs breath)', benefit2: 'Steel vs brass — tone notes' },
    // ---- Sound healing sub-topics ----
    { key: 'gongs', image: IMG_CDN + '20-inch-chinese-chau-gong-percussion-instrument-20-distant-sun-945.jpg?v=1733773854', test: /(\bgong\b|chau[-_ ]gong|wind[-_ ]gong|flower[-_ ]of[-_ ]life[-_ ]gong|paiste|symphonic)/i, eyebrow: 'For gong practitioners', headline: 'Your first gong session is closer than you think', sub: 'Join our circle for gong care + practice notes + 10% off your first piece.', benefit1: 'Curated gong pairing guide (free PDF)', benefit2: 'Weekly practice ideas from experienced gong masters' },
    { key: 'singing_bowls', image: IMG_CDN + '1.11_b78991ad-f9d9-4cfd-a287-d40f83526d45.jpg?v=1768147113', test: /(singing[-_ ]bowl|himalayan[-_ ]bowl|crystal[-_ ]bowl|quartz[-_ ]bowl|tibetan[-_ ]bowl)/i, eyebrow: 'For bowl practitioners', headline: 'The bowl that fits your practice', sub: 'Sizing, tone, and selection notes — plus 10% off your first bowl.', benefit1: 'Our "which bowl for which intention" guide', benefit2: 'Tuning-by-ear basics for beginners' },
    { key: 'tuning_forks', image: IMG_CDN + '17-piece-solfeggio-chakra-tuning-fork-set-bags-strikers-collection-colorful-524.jpg?v=1737802757', test: /(tuning[-_ ]fork|otto[-_ ]tuner|weighted[-_ ]fork|solfeggio|432[-_ ]?hz|528[-_ ]?hz)/i, eyebrow: 'For fork practitioners', headline: 'Tuning forks, demystified', sub: 'Weighted vs unweighted, how to strike, what to pair — plus 10% off.', benefit1: 'Fork technique fundamentals (free guide)', benefit2: 'New technique notes every other week' },
    { key: 'palo_santo_incense', image: IMG_CDN + '60688abd8a392480a43a3c2d6550cdcc.jpg?v=1751111709', test: /(palo[-_ ]santo|incense|sage|smudge|cedar|copal|resin)/i, eyebrow: 'For daily ritual', headline: 'A quieter start to your day', sub: 'Ritual inspiration + 10% off your first bundle of tools.', benefit1: 'Simple 5-minute morning ritual templates', benefit2: 'Ethically sourced notes you can share' },
    { key: 'meditation_practice', image: IMG_CDN + '5d1687738472783de609730120235bc1.jpg?v=1751129007', test: /(meditation|mindful|breathwork|pranayama|yoga[-_ ]nidra|zen)/i, eyebrow: 'For daily practice', headline: 'Daily practice ideas, straight to your inbox', sub: 'Short emails · gentle guidance · 10% off tools when you\u2019re ready.', benefit1: 'Weekly guided practice prompts', benefit2: 'Community-favorite tool recommendations' },
    { key: 'chakras_spiritual', image: IMG_CDN + '17-piece-solfeggio-chakra-tuning-fork-set-bags-strikers-collection-colorful-524.jpg?v=1737802757', test: /(\bchakra|aura|angel[-_ ]number|manifest|tarot|energy[-_ ]work|third[-_ ]eye|kundalini)/i, eyebrow: 'For your practice', headline: 'Gentle notes for your spiritual path', sub: 'Weekly reflections + 10% off when you\u2019re ready to bring a tool home.', benefit1: 'Tradition-rooted explanations (no woo-woo)', benefit2: 'Respectful, practical guidance' },
    { key: 'amethyst_quartz', image: IMG_CDN + '2-inch-dream-amethyst-anka-crystal-figurine-figurines-carvings-buy-417.jpg?v=1755487966', test: /(amethyst|quartz|rose[-_ ]quartz|clear[-_ ]quartz|citrine|selenite)/i, eyebrow: 'For crystal lovers', headline: 'The clearest guide to your first stone', sub: 'Selection notes, care tips, and 10% off your first piece.', benefit1: 'How to tell quality from mass-market', benefit2: 'Care & cleansing basics' },
    { key: 'crystals_generic', image: IMG_CDN + '2-inch-blue-copras-crystal-cluster-healing-spiritual-energy-raw-722.jpg?v=1754633744', test: /(crystal|geode|cluster|tumbled[-_ ]stone|mineral|raw[-_ ]stone)/i, eyebrow: 'For crystal lovers', headline: 'Join our crystal community', sub: 'Weekly crystal notes + 10% off your first stone.', benefit1: 'Curator-picked stone of the month', benefit2: 'Ethically sourced always' },
    { key: 'mala_108', image: IMG_CDN + 'efcdc605-6d83-4b2f-a711-34d148927587.jpg?v=1751139175', test: /(\bmala\b|108[-_ ]?bead|rudraksha|bodhi[-_ ]seed|prayer[-_ ]bead)/i, eyebrow: 'For mala wearers', headline: 'The 108-bead tradition, in your inbox', sub: 'Mala wisdom, care, and 10% off your first piece.', benefit1: 'How to use your mala for daily japa', benefit2: 'Tradition-rooted, quiet essays' },
    { key: 'jewelry_generic', image: IMG_CDN + '16-18cm-blue-tiger-eye-protection-strength-bracelet-180.jpg?v=1768397481', test: /(bracelet|necklace|pendant|anklet|earring|talisman|amulet)/i, eyebrow: 'For meaningful pieces', headline: 'Pieces that carry meaning', sub: 'Care notes, styling, and 10% off your first bracelet or pendant.', benefit1: 'Materials + sourcing transparency', benefit2: 'New pieces, first access' },
    { key: 'home_decor', image: IMG_CDN + '1723391039.jpg?v=1751908187', test: /(buddha|statue|tapestry|wall[-_ ]hanging|feng[-_ ]shui|altar|sculpture|dreamcatcher)/i, eyebrow: 'For sacred spaces', headline: 'Ideas for your sacred corner', sub: 'Altar + space inspiration + 10% off when you\u2019re ready.', benefit1: 'Altar setup guides for small spaces', benefit2: 'Seasonal space refresh ideas' },
    { key: 'apparel_meditation', image: IMG_CDN + '2e60a287-0ca5-4f87-90d4-b51b1a7e43ee_d2491bc4-ba88-4606-902b-6b46be8eccba.jpg?v=1752057198', test: /(meditation[-_ ]shawl|prayer[-_ ]shawl|meditation[-_ ]wrap|zen[-_ ]wear|yoga[-_ ]apparel|\bshawl\b|\bscarf\b)/i, eyebrow: 'For long sits', headline: 'Comfort you\u2019ll feel for hours', sub: 'Fabric notes + 10% off your first wrap.', benefit1: 'Sizing guide (demystified)', benefit2: 'Made for practice, not just aesthetic' },
    { key: 'sound_healing', image: IMG_CDN + 'b2-mystic-handpan-drum-perfect-beginners-pros-gold-432-hz-9-golden-bronze-707.jpg?v=1737855085', test: /(sound[-_ ]healing|frequency|vibration|resonance|handpan|kalimba|chime|drum)/i, eyebrow: 'For sound seekers', headline: 'Discover the magic of sound healing', sub: 'Get free sound healing notes + 10% off your first piece.', benefit1: 'Beginner-friendly practice guides', benefit2: 'New piece recommendations curated for you' }
  ];
  var DEFAULT_TOPIC = {
    key: 'default',
    image: IMG_CDN + '26-chau-gong-c-stand-meditation-instrument-large-chinese-156.jpg?v=1733775344',
    eyebrow: 'Welcome',
    headline: 'Join our circle',
    sub: 'Weekly notes + 10% off your first order.',
    benefit1: 'Gentle, thoughtful emails — never spam',
    benefit2: 'First access to new pieces + seasonal notes'
  };

  function classifyTopic() {
    var urlPath = (location.pathname || '') + ' ' + (location.search || '');
    var h1El = document.querySelector('article h1, main h1, h1');
    var h1Text = (h1El && h1El.textContent) ? h1El.textContent : '';
    var titleText = document.title || '';
    var haystack = [urlPath, h1Text, titleText].join(' ');
    for (var i = 0; i < TOPICS.length; i++) {
      if (TOPICS[i].test.test(haystack)) return TOPICS[i];
    }
    return DEFAULT_TOPIC;
  }
  var topic = classifyTopic();

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (k === 'style') n.style.cssText = attrs[k];
        else if (k === 'html') n.innerHTML = attrs[k];
        else if (k.indexOf('on') === 0) n.addEventListener(k.slice(2), attrs[k]);
        else n.setAttribute(k, attrs[k]);
      }
    }
    if (children) {
      (Array.isArray(children) ? children : [children]).forEach(function(c) {
        if (c != null) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
    }
    return n;
  }
  function visitorId() {
    try {
      if (typeof window.ctwGetVisitorId === 'function') {
        var fromApi = window.ctwGetVisitorId();
        if (fromApi) return fromApi;
      }
      var m = document.cookie.match(/(?:^|; )_ctw_vid=([^;]+)/);
      if (m) return decodeURIComponent(m[1]);
    } catch (e) {}
    return null;
  }
  function track(event, payload) {
    payload = payload || {};
    try { if (typeof window.ctwTrack === 'function') window.ctwTrack(event, payload); } catch (e) {}
    try {
      var body = JSON.stringify({
        event: event.replace(/^blog_popup_/, ''),
        topic: payload.topic || topic.key,
        url: payload.url || location.href,
        title: (document.title || '').slice(0, 240),
        visitor_id: visitorId(),
        referrer: document.referrer || null,
        error_code: payload.error_code || null
      });
      var url = CFG.apiBase + '/api/blog-popup/track';
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'application/json' });
        navigator.sendBeacon(url, blob);
      } else {
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: body,
          keepalive: true
        }).catch(function(){});
      }
    } catch (e) {}
  }

  var B = CFG.brandPrimary;
  var BD = CFG.brandDark;
  var css = [
    '@keyframes hsBlogFade{from{opacity:0}to{opacity:1}}',
    '@keyframes hsBlogPopIn{from{opacity:0;transform:translateY(20px) scale(.96)}to{opacity:1;transform:translateY(0) scale(1)}}',
    '@keyframes hsBlogShake{0%,100%{transform:translateX(0)}25%{transform:translateX(-6px)}75%{transform:translateX(6px)}}',
    '.hs-blog-overlay{position:fixed;inset:0;background:rgba(20,15,30,.68);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);z-index:2147483600;display:none;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;font:14px/1.45 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;color:#18181b;}',
    '.hs-blog-overlay.open{display:flex;animation:hsBlogFade .22s ease-out;}',
    '.hs-blog-modal{position:relative;background:#fff;color:#18181b;border-radius:18px;box-shadow:0 30px 80px rgba(0,0,0,.42),0 6px 20px rgba(0,0,0,.2);display:flex;flex-direction:row;width:100%;max-width:820px;max-height:calc(100vh - 32px);overflow:hidden;animation:hsBlogPopIn .32s cubic-bezier(.34,1.56,.64,1);}',
    '.hs-blog-close{position:absolute;top:10px;right:10px;width:34px;height:34px;border-radius:50%;background:rgba(255,255,255,.95);border:none;cursor:pointer;color:#18181b;font-size:22px;line-height:1;display:flex;align-items:center;justify-content:center;z-index:3;transition:background .15s,transform .15s;box-shadow:0 2px 8px rgba(0,0,0,.18);}',
    '.hs-blog-close:hover{background:#fff;transform:rotate(90deg);}',
    '.hs-blog-img-wrap{flex:0 0 42%;min-height:460px;background:#f0ebf6 center/cover no-repeat;position:relative;}',
    '.hs-blog-img-wrap:after{content:"";position:absolute;inset:0;background:linear-gradient(180deg,rgba(150,122,182,0) 55%,rgba(122,95,154,.35) 100%);pointer-events:none;}',
    '.hs-blog-pane{flex:1 1 58%;padding:32px 28px 24px;display:flex;flex-direction:column;justify-content:center;min-width:0;overflow-y:auto;}',
    '.hs-blog-eyebrow{display:inline-block;font:700 10.5px/1 sans-serif;letter-spacing:1.8px;text-transform:uppercase;color:' + B + ';background:rgba(150,122,182,.12);padding:5px 9px;border-radius:4px;margin:0 0 12px;align-self:flex-start;}',
    '.hs-blog-title{font:700 26px/1.2 Georgia,"Times New Roman",serif;margin:0 0 8px;color:#18181b;letter-spacing:-.3px;}',
    '.hs-blog-sub{font:400 14.5px/1.5 sans-serif;color:#52525b;margin:0 0 14px;}',
    '.hs-blog-offer{display:flex;align-items:stretch;border:1.5px dashed ' + B + ';border-radius:10px;margin:0 0 14px;background:linear-gradient(135deg,rgba(150,122,182,.06) 0%,rgba(150,122,182,.12) 100%);overflow:hidden;}',
    '.hs-blog-offer-badge{background:linear-gradient(135deg,' + B + ' 0%,' + BD + ' 100%);color:#fff;font:900 20px/1 sans-serif;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:10px 14px;flex-shrink:0;letter-spacing:-.5px;}',
    '.hs-blog-offer-badge strong{font-size:22px;display:block;}',
    '.hs-blog-offer-badge span{font:700 9px/1 sans-serif;letter-spacing:1.5px;text-transform:uppercase;opacity:.92;margin-top:3px;}',
    '.hs-blog-offer-text{padding:8px 12px;display:flex;flex-direction:column;justify-content:center;flex:1;min-width:0;}',
    '.hs-blog-offer-text strong{font:700 13.5px/1.25 sans-serif;color:#18181b;display:block;margin:0 0 1px;}',
    '.hs-blog-offer-text span{font:500 11.5px/1.35 sans-serif;color:#52525b;}',
    '.hs-blog-social{display:flex;align-items:center;gap:8px;margin:0 0 16px;}',
    '.hs-blog-social-avatars{display:flex;}',
    '.hs-blog-social-avatars img{width:22px;height:22px;border-radius:50%;border:2px solid #fff;object-fit:cover;margin-left:-6px;display:block;}',
    '.hs-blog-social-avatars img:first-child{margin-left:0;}',
    '.hs-blog-social-text{font:500 12px/1.35 sans-serif;color:#52525b;}',
    '.hs-blog-social-text strong{color:#18181b;font-weight:600;}',
    '.hs-blog-social-stars{color:#05B67A;letter-spacing:.5px;margin-right:3px;font-size:12px;}',
    '.hs-blog-form{display:flex;flex-direction:column;gap:9px;}',
    '.hs-blog-input{width:100%;box-sizing:border-box;padding:14px 14px;border:1.5px solid #e4e4e7;border-radius:10px;outline:none;font:500 15px sans-serif;background:#fff;color:#18181b;-webkit-appearance:none;transition:border-color .15s,box-shadow .15s;}',
    '.hs-blog-input::placeholder{color:#a1a1aa;}',
    '.hs-blog-input:focus{border-color:' + B + ';box-shadow:0 0 0 3px rgba(150,122,182,.18);}',
    '.hs-blog-input.error{border-color:#EF4444;animation:hsBlogShake .3s ease-out;}',
    '.hs-blog-err{color:#EF4444;font:500 12px sans-serif;min-height:16px;margin:0;display:none;}',
    '.hs-blog-err.show{display:block;}',
    '.hs-blog-btn{display:flex;align-items:center;justify-content:center;gap:6px;width:100%;padding:15px 16px;border:none;border-radius:10px;background:' + B + ';background:linear-gradient(135deg,' + B + ' 0%,' + BD + ' 100%);color:#fff;font:700 15px sans-serif;cursor:pointer;transition:transform .06s,box-shadow .15s,opacity .15s;box-shadow:0 6px 18px rgba(150,122,182,.4);letter-spacing:.2px;-webkit-tap-highlight-color:transparent;}',
    '.hs-blog-btn:hover:not(:disabled){box-shadow:0 8px 22px rgba(150,122,182,.52);}',
    '.hs-blog-btn:active:not(:disabled){transform:scale(.98);}',
    '.hs-blog-btn:disabled{opacity:.65;cursor:not-allowed;}',
    '.hs-blog-benefits{display:flex;flex-direction:column;gap:5px;margin:11px 0 4px;padding:0 2px;}',
    '.hs-blog-benefits li{list-style:none;font:500 12.5px/1.4 sans-serif;color:#52525b;display:flex;align-items:flex-start;gap:7px;}',
    '.hs-blog-benefits li:before{content:"\u2713";color:' + B + ';font-weight:700;font-size:13px;line-height:1.35;flex-shrink:0;}',
    '.hs-blog-micro{font:500 11.5px/1.35 sans-serif;color:#71717a;text-align:center;margin:10px 0 0;}',
    '.hs-blog-micro strong{color:#18181b;font-weight:600;}',
    '.hs-blog-legal{font:400 10.5px/1.45 sans-serif;color:#a1a1aa;text-align:center;margin:9px 4px 0;}',
    '.hs-blog-legal a{color:#71717a;text-decoration:underline;}',
    '.hs-blog-skip{display:block;background:none;border:0;font:500 11.5px/1 sans-serif;color:#a1a1aa;text-decoration:underline;margin:11px auto 0;cursor:pointer;padding:4px 8px;}',
    '.hs-blog-skip:hover{color:#71717a;}',
    '.hs-blog-success{text-align:center;padding:8px 4px 0;}',
    '.hs-blog-success-icon{width:68px;height:68px;border-radius:50%;background:linear-gradient(135deg,#eadefb,#d6c6eb);display:flex;align-items:center;justify-content:center;margin:0 auto 16px;}',
    '.hs-blog-success-icon svg{width:34px;height:34px;stroke:' + B + ';fill:none;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}',
    '.hs-blog-success h3{font:700 22px/1.25 Georgia,serif;margin:0 0 8px;color:#18181b;}',
    '.hs-blog-success p{font:400 14px/1.45 sans-serif;color:#52525b;margin:0 0 6px;}',
    '.hs-blog-success .code{display:inline-block;background:rgba(150,122,182,.14);color:' + BD + ';font:700 14px/1 monospace,"Consolas";letter-spacing:1.2px;padding:7px 12px;border-radius:6px;margin:6px 0 2px;}',
    '@media (max-width:640px){',
    '  .hs-blog-overlay{padding:0;align-items:flex-end;}',
    '  .hs-blog-modal{flex-direction:column;max-height:96vh;max-width:100%;border-radius:18px 18px 0 0;width:100%;}',
    '  .hs-blog-img-wrap{flex:0 0 160px;min-height:160px;}',
    '  .hs-blog-pane{padding:22px 20px 18px;}',
    '  .hs-blog-title{font-size:21px;line-height:1.2;margin-bottom:6px;}',
    '  .hs-blog-sub{font-size:13.5px;margin-bottom:12px;}',
    '  .hs-blog-social{margin-bottom:12px;}',
    '  .hs-blog-btn{padding:15px 16px;font-size:15.5px;}',
    '  .hs-blog-benefits{margin:9px 0 2px;}',
    '  .hs-blog-close{top:6px;right:6px;}',
    '}',
    '@media (prefers-reduced-motion:reduce){',
    '  .hs-blog-overlay.open,.hs-blog-modal,.hs-blog-input.error{animation:none!important;}',
    '}'
  ].join('');
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var overlay = el('div', { 'class': 'hs-blog-overlay', 'role': 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'hs-blog-title' });
  var modal = el('div', { 'class': 'hs-blog-modal' });
  var imgWrap = el('div', {
    'class': 'hs-blog-img-wrap',
    'role': 'img',
    'aria-label': 'Healing Sounds lifestyle image'
  });
  // Hero image resolution: topic-specific first, theme asset, then product CDN.
  var heroPrimary = topic.image || CFG.lifestyleImg;
  var heroFallback = CFG.lifestyleImg && topic.image && CFG.lifestyleImg !== topic.image
    ? CFG.lifestyleImg
    : CFG.lifestyleFallback;
  var hiddenImg = new Image();
  hiddenImg.onload = function() {
    imgWrap.style.backgroundImage = 'url(' + JSON.stringify(heroPrimary).slice(1, -1) + ')';
  };
  hiddenImg.onerror = function() {
    var fallback = new Image();
    fallback.onload = function() {
      imgWrap.style.backgroundImage = 'url(' + JSON.stringify(heroFallback).slice(1, -1) + ')';
    };
    fallback.onerror = function() {
      var last = new Image();
      last.onload = function() {
        imgWrap.style.backgroundImage = 'url(' + JSON.stringify(CFG.lifestyleFallback).slice(1, -1) + ')';
      };
      last.src = CFG.lifestyleFallback;
    };
    fallback.src = heroFallback;
  };
  hiddenImg.src = heroPrimary;

  var pane = el('div', { 'class': 'hs-blog-pane' });
  var closeBtn = el('button', { type: 'button', 'class': 'hs-blog-close', 'aria-label': 'Close', onclick: dismiss }, '\u00D7');
  modal.appendChild(closeBtn);

  pane.appendChild(el('div', { 'class': 'hs-blog-eyebrow' }, topic.eyebrow));
  pane.appendChild(el('h3', { 'class': 'hs-blog-title', id: 'hs-blog-title' }, topic.headline));
  pane.appendChild(el('p', { 'class': 'hs-blog-sub' }, topic.sub));

  // Prominent offer pill — value-prop hero above the form.
  var offerWrap = el('div', { 'class': 'hs-blog-offer' });
  var offerBadge = el('div', { 'class': 'hs-blog-offer-badge' });
  offerBadge.innerHTML = '<strong>10%</strong><span>OFF</span>';
  offerWrap.appendChild(offerBadge);
  var offerText = el('div', { 'class': 'hs-blog-offer-text' });
  offerText.innerHTML = '<strong>Your first order</strong><span>No minimum \u00B7 code sent to your inbox</span>';
  offerWrap.appendChild(offerText);
  pane.appendChild(offerWrap);

  var socialWrap = el('div', { 'class': 'hs-blog-social' });
  var avatarsBox = el('div', { 'class': 'hs-blog-social-avatars' });
  CFG.avatars.forEach(function(src){
    var img = new Image();
    img.src = src; img.alt = '';
    avatarsBox.appendChild(img);
  });
  socialWrap.appendChild(avatarsBox);
  var socialText = el('div', { 'class': 'hs-blog-social-text' });
  socialText.innerHTML = '<span class="hs-blog-social-stars">\u2605\u2605\u2605\u2605\u2605</span><strong>4.7/5</strong> \u00B7 <strong>13,000+ clients</strong> worldwide';
  socialWrap.appendChild(socialText);
  pane.appendChild(socialWrap);

  var form = el('form', { 'class': 'hs-blog-form', onsubmit: onSubmit, novalidate: 'novalidate', autocomplete: 'on' });
  var emailInput = el('input', {
    'class': 'hs-blog-input',
    type: 'email',
    name: 'email',
    inputmode: 'email',
    required: 'required',
    autocomplete: 'email',
    autocapitalize: 'off',
    autocorrect: 'off',
    spellcheck: 'false',
    placeholder: 'your@email.com',
    'aria-label': 'Email address'
  });
  form.appendChild(emailInput);
  var errEl = el('p', { 'class': 'hs-blog-err', role: 'alert' }, '');
  form.appendChild(errEl);
  var submitBtn = el('button', { type: 'submit', 'class': 'hs-blog-btn' }, 'Send me my 10%');
  form.appendChild(submitBtn);
  pane.appendChild(form);

  var benefitsUl = el('ul', { 'class': 'hs-blog-benefits' });
  benefitsUl.appendChild(el('li', {}, topic.benefit1 || 'Gentle, thoughtful emails'));
  benefitsUl.appendChild(el('li', {}, topic.benefit2 || 'Unsubscribe anytime'));
  pane.appendChild(benefitsUl);

  var micro = el('p', { 'class': 'hs-blog-micro' });
  micro.innerHTML = '\u23F1 <strong>Your code arrives in 2 min.</strong> No spam \u2014 just wisdom notes.';
  pane.appendChild(micro);

  pane.appendChild(el('div', { 'class': 'hs-blog-legal' },
    'By subscribing you agree to receive marketing emails from ' + CFG.brand + '. Unsubscribe anytime.'
  ));
  pane.appendChild(el('button', { type: 'button', 'class': 'hs-blog-skip', onclick: dismiss }, 'Maybe later'));

  modal.appendChild(imgWrap);
  modal.appendChild(pane);
  overlay.appendChild(modal);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) dismiss(); });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('open')) dismiss();
  });
  document.body.appendChild(overlay);

  var shown = false;
  function show() {
    if (shown) return;
    shown = true;
    overlay.classList.add('open');
    setTimeout(function() { try { emailInput.focus({ preventScroll: true }); } catch (e) {} }, 340);
    track('blog_popup_shown', { topic: topic.key, url: location.href });
    try { document.documentElement.style.overflow = 'hidden'; } catch (e) {}
  }
  function dismiss() {
    overlay.classList.remove('open');
    try { document.documentElement.style.overflow = ''; } catch (e) {}
    try {
      if (!isTestMode) localStorage.setItem(LS_DISMISSED, String(Date.now()));
    } catch (e) {}
    track('blog_popup_dismissed', { topic: topic.key, url: location.href });
  }

  function onSubmit(e) {
    e.preventDefault();
    var value = (emailInput.value || '').trim();
    errEl.classList.remove('show');
    errEl.textContent = '';
    emailInput.classList.remove('error');

    if (!value || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
      emailInput.classList.add('error');
      errEl.textContent = 'Please enter a valid email address.';
      errEl.classList.add('show');
      try { emailInput.focus(); } catch (er) {}
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending\u2026';

    var payload = {
      email: value,
      topic: topic.key,
      url: location.href,
      title: (document.title || '').slice(0, 240),
      visitor_id: visitorId()
    };

    fetch(CFG.apiBase + '/api/blog-popup/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(r) { return r.json().catch(function() { return { ok: false, error: 'bad_json' }; }); })
    .then(function(d) {
      if (d && d.ok) {
        try { if (!isTestMode) localStorage.setItem(LS_SUBSCRIBED, '1'); } catch (er) {}
        track('blog_popup_subscribed', { topic: topic.key, url: location.href, already: !!d.already_subscribed });
        renderSuccess(!!d.already_subscribed);
        setTimeout(dismiss, CFG.successAutoCloseMs);
      } else {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send me my 10%';
        emailInput.classList.add('error');
        errEl.textContent = errorLabel(d && d.error);
        errEl.classList.add('show');
        track('blog_popup_error', { topic: topic.key, url: location.href, error_code: (d && d.error) || 'unknown' });
      }
    })
    .catch(function() {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Send me my 10%';
      errEl.textContent = 'Network error \u2014 please try again.';
      errEl.classList.add('show');
      track('blog_popup_error', { topic: topic.key, url: location.href, error_code: 'network' });
    });
  }

  function errorLabel(code) {
    switch (code) {
      case 'invalid_email': return 'That email doesn\u2019t look right.';
      case 'email_required': return 'Please enter your email.';
      case 'rate_limited': return 'Too many attempts \u2014 try again shortly.';
      default: return 'Something went wrong. Please try again.';
    }
  }

  function renderSuccess(alreadySubscribed) {
    pane.innerHTML = '';
    var wrap = el('div', { 'class': 'hs-blog-success' });
    var icon = el('div', { 'class': 'hs-blog-success-icon' });
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.innerHTML = '<polyline points="5 12 10 17 20 7"/>';
    icon.appendChild(svg);
    wrap.appendChild(icon);
    if (alreadySubscribed) {
      wrap.appendChild(el('h3', {}, 'Welcome back to the circle'));
      wrap.appendChild(el('p', {}, 'You\u2019re already part of our community \u2014 so good to see you again.'));
      wrap.appendChild(el('p', { style: 'margin-top:8px;font-size:13.5px;color:#52525b;' },
        'Ready to bring a piece home? Your 10% welcome code \u2014 HELLO10 \u2014 works on your first order if you haven\u2019t used it yet.'
      ));
      // Topic-specific Shopify search URL — always returns relevant products,
      // no risk of 404 on missing collection handles.
      var searchKeyword = topic.searchKeyword || (topic.key === 'default' ? '' : topic.key.replace(/_/g, ' '));
      var ctaUrl = searchKeyword
        ? 'https://healing-sounds.com/search?q=' + encodeURIComponent(searchKeyword) + '&type=product&utm_source=blog_popup&utm_medium=returning&utm_campaign=' + topic.key
        : 'https://healing-sounds.com/collections/all?utm_source=blog_popup&utm_medium=returning&utm_campaign=' + topic.key;
      var ctaLabel = searchKeyword ? 'See our ' + searchKeyword + ' picks' : 'Browse the shop';
      var shopBtn = el('a', { href: ctaUrl, 'class': 'hs-blog-btn', style: 'margin-top:12px;text-decoration:none;' }, ctaLabel);
      wrap.appendChild(shopBtn);
    } else {
      wrap.appendChild(el('h3', {}, 'Check your inbox!'));
      wrap.appendChild(el('p', {}, 'Your welcome note \u2014 with the code below \u2014 is on its way.'));
      wrap.appendChild(el('div', { 'class': 'code' }, 'HELLO10'));
      wrap.appendChild(el('p', { style: 'margin-top:6px;font-size:12px;color:#71717a;' },
        'Valid on your first order \u00B7 no minimum \u00B7 we\u2019ll close this in a moment'
      ));
    }
    pane.appendChild(wrap);
  }

  // Triggers — first to fire wins:
  //   1. Scroll past N% of document          (mobile 25%, desktop 30%)
  //   2. Scroll-then-pause                   (mobile + desktop, replaces exit-intent on touch)
  //   3. Exit-intent (cursor leaves top)     (DESKTOP ONLY — touch has no mouseleave)
  //   4. Time on page > Nms                  (mobile 12s, desktop 18s)
  //
  // Scroll-pause trigger added 2026-04-26 to fix mobile coverage —
  // mobile fired on 0.07% of views (vs 11.3% desktop) because exit-intent
  // doesn't work on touch + the 25s timer was longer than typical mobile
  // session. New trigger captures "scrolled then stopped to read".
  var hasScrolledEnough = false;
  var scrollPauseTimer = null;

  function onScroll() {
    if (shown) return;
    var doc = document.documentElement;
    var total = Math.max(1, (doc.scrollHeight || document.body.scrollHeight) - window.innerHeight);
    var pct = (window.scrollY / total) * 100;
    if (pct >= CFG.scrollPct) {
      show();
      return;
    }
    if (window.scrollY >= CFG.scrollPausePixels) {
      hasScrolledEnough = true;
    }
    if (hasScrolledEnough) {
      if (scrollPauseTimer) clearTimeout(scrollPauseTimer);
      scrollPauseTimer = setTimeout(function() {
        if (!shown) show();
      }, CFG.scrollPauseMs);
    }
  }
  function onExitIntent(e) {
    if (shown) return;
    if (!e.relatedTarget && !e.toElement && e.clientY !== null && e.clientY < 10) {
      show();
    }
  }

  if (isTestMode) {
    setTimeout(show, 300);
  } else {
    window.addEventListener('scroll', onScroll, { passive: true });
    // Exit-intent: desktop only (mobile has no mouseleave-style equivalent).
    if (!isMobile) document.addEventListener('mouseout', onExitIntent);
    setTimeout(function(){ if (!shown) show(); }, CFG.timeTriggerMs);
  }

  window.HsBlogPopup = {
    open: show,
    close: dismiss,
    topic: topic,
    reset: function() {
      try {
        localStorage.removeItem(LS_DISMISSED);
        localStorage.removeItem(LS_SUBSCRIBED);
      } catch (e) {}
      shown = false;
    },
    version: 2,
    source: 'theme-asset'
  };
  try { window.dispatchEvent(new CustomEvent('hs-blog-popup-ready', { detail: { topic: topic.key } })); } catch (e) {}
})();
